import { graphql } from '../../graphql';

export const requestPasswordReset = graphql(`
  mutation RequestPasswordReset($email: String!) {
    requestPasswordReset(input: { email: $email }) {
      errors {
        message
        path
      }
      status
    }
  }
`);
